import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CreateFilterCategoryInput, DeleteFilterCategoryInput, FilterCategory, GraphDotnetService, graphql, Store, UpdateFilterCategoryInput } from 'app/shared/graph';

@Injectable({
    providedIn: 'root'
})
export class FilterCategoryService {
    private readonly graphDotnetService = inject(GraphDotnetService);

    loadStoreFilterCategories(storeId: string): Observable<Store> {
        return this.graphDotnetService.query(graphql`
                query filterCategories($storeId: String!) {
                    store(id: $storeId) {
                        subscriptionId
                        filterCategories {
                            id
	                        label
                            builtInFilters
                            remoteFilters {
                                id
                                name
                                urlThumb
                            }
                        }
                    }
                }
            `,
            {
                storeId
            }
        ).pipe(map(q => q.store));
    }

    createFilterCategory(input: CreateFilterCategoryInput): Observable<FilterCategory> {
        return this.graphDotnetService.mutate(
            graphql`mutation CreateFilterCategory($input: CreateFilterCategoryInput!) {
                createFilterCategory(input: $input) {
                    id
                    label
                    builtInFilters
                    remoteFilters {
                        id
                        name
                        urlThumb
                    }
                }
            }`, { input }
        ).pipe(map(x => x.createFilterCategory));
    }

    deleteFilterCategory(input: DeleteFilterCategoryInput): Observable<void> {
        return this.graphDotnetService.mutate(
            graphql`mutation DeleteFilterCategory($input: DeleteFilterCategoryInput!) {
                deleteFilterCategory(input: $input)
            }`, { input }
        ).pipe(map(x => x.deleteFilterCategory));
    }

    updateFilterCategory(input: UpdateFilterCategoryInput): Observable<void> {
        return this.graphDotnetService.mutate(
            graphql`mutation UpdateFilterCategory($input: UpdateFilterCategoryInput!) {
                updateFilterCategory(input: $input)
            }`, { input }
        ).pipe(map(x => x.updateFilterCategory));
    }
}
